import React, { useRef } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

// layout constants
import { LayoutTypes } from "../constants/layout";

// strore
import { RootState } from "../redux/store";

// All layouts containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";
import DetachedLayout from "../layouts/Detached";
import HorizontalLayout from "../layouts/Horizontal/";
import TwoColumnLayout from "../layouts/TwoColumn/";

import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from "./index";

import { APICore } from "../helpers/api/apiCore";
import RoleGuard from "../components/RoleGuard";

interface RoutesProps {}

const AllRoutes = (props: RoutesProps) => {
const layout = useSelector((state: RootState) => state.Layout);
// Subscribe to auth state so this component re-renders after login/logout,
// ensuring the inline api.isUserAuthenticated() calls below are fresh.
useSelector((state: RootState) => (state as any).Auth?.userLoggedIn);

  const getLayout = () => {
    let layoutCls = TwoColumnLayout;

    switch (layout.layoutType) {
      case LayoutTypes.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case LayoutTypes.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      case LayoutTypes.LAYOUT_VERTICAL:
        layoutCls = VerticalLayout;
        break;
      default:
        layoutCls = TwoColumnLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();
  const api = useRef(new APICore()).current;

  return (
    <React.Fragment>
      <Routes>
        {/* Redirect root URL to "/landing" */}
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route>
          {publicProtectedFlattenRoutes.map((route, idx) => (
            <Route
              path={route.path} // /auth/login, /auth/register
              element={
                <DefaultLayout {...props} layout={layout}>
                  {route.element}
                </DefaultLayout>
              }
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {authProtectedFlattenRoutes.filter((r) => r.element).map((route, idx) => (
            <Route
              path={route.path}
              element={
                api.isUserAuthenticated() === false ? (
                  <Navigate
                    to={{
                      pathname: "auth/login",
                      search: "next=" + route.path,
                    }}
                  />
                ) : (
                  <Layout {...props}>
                    <RoleGuard>{route.element}</RoleGuard>
                  </Layout>
                )
              }
              key={idx}
            />
          ))}
        </Route>
        {/* Add the catch-all route to redirect to the home page */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </React.Fragment>
  );
};

export default AllRoutes;
